var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 361,
    viewBox: "0 0 361 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M164.177 0.063133L174.659 150.764L127.363 7.26041L97.0539 19.6347L164.303 156.193L64.4079 41.3527L41.2968 64.5229L155.337 163.643L20.3958 95.648L7.76684 125.763L151.864 174.818L0 164.211V196.915L150.727 186.435L7.19853 233.722L19.575 264.026L156.158 196.662L41.2968 296.603L64.4079 319.71L163.546 205.69L95.6015 340.608L125.785 353.235L174.785 209.163L164.177 361H196.886L186.278 210.299L233.637 353.803L263.946 341.428L196.634 204.87L296.529 319.71L319.64 296.603L205.663 197.483L340.604 265.478L353.233 235.3L209.136 186.308L361 196.852V164.148L210.273 174.692L353.801 127.404L341.425 97.1L204.842 164.338L319.703 64.4598L296.592 41.3527L197.454 155.31L265.462 20.5185L235.341 7.89175L186.278 151.837L196.886 0H164.177V0.063133Z",
    fill: "url(#paint0_radial_174_651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_174_651",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.93 180.626) rotate(139.928) scale(181.552 181.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "custom-color",
    offset: 0.68,
    stopColor: "#CB670B",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041B04",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadial);
export default __webpack_public_path__ + "static/media/radial.12034de2b4b51069910b5c87bb10f2b9.svg";
export { ForwardRef as ReactComponent };